/* eslint-disable max-statements */
import {useEffect, useMemo, useState} from 'react';
import {useTable, usePagination, useFilters, useRowSelect} from 'react-table';
import {TableFilter} from './table/tableFilters';
import {useDispatch, useSelector} from 'react-redux';
import {Actions} from '../../../common/actions';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {paths} from '../../../common/dictionaries/urls';
import {tableHeaderWithProps} from './table/columns';

const {
  clearFloatingInventoryReport,
  fetchDealers,
  fetchVehiclesModelsList,
  fetchVehiclesOrders,
  navigateTo,
} = Actions;

export const useFloatingReport = () => {
  const dispatch = useDispatch();
  const {
    loading,
    'data': reportData,
  } = useSelector((state) => state.floatingInventoryReport);
  const {'isUserFromTDE': isUserTde, dealerId} = useSelector((state) => state.session);
  const permissions = useSelector((state) => state.session.permissions);
  const [resetAllFilters, setResetAllFilters] = useState(false);

  const data = useMemo(() => reportData, [reportData]);
  const columns = useMemo(() => tableHeaderWithProps(isUserTde, dealerId), [isUserTde]);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    setAllFilters,
    filteredRows,
    'state': {pageIndex, pageSize},
  } = useTable(
    {
      columns,
      data,
      'defaultColumn': {'Filter': TableFilter},
      'initialState': {'pageIndex': 0, 'pageSize': 20},
      'autoResetFilters': true,
    },
    useFilters,
    usePagination,
    useRowSelect
  );
  
  useEffect(() => {
    dispatch(fetchDealers('float'));
    dispatch(fetchVehiclesModelsList());
    dispatch(fetchVehiclesOrders());
  }, []);

  useEffect(() => {
    return () => dispatch(clearFloatingInventoryReport());
  }, []);

  useEffect(() => {
    if (resetAllFilters) {
      setAllFilters([]);
      setResetAllFilters(false);
    }
  }, [resetAllFilters]);
  
  useEffect(() => {
    if (!hasAccessPermission(permissions, resources.FloatingInventoryReport, scopes.See)) {
      dispatch(navigateTo(paths.AccessDenied));
    }
  }, []);

  return {
    'actions': {
      setResetAllFilters,
      'useTableValues': {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        page,
        canPreviousPage,
        canNextPage,
        pageOptions,
        gotoPage,
        nextPage,
        previousPage,
        setPageSize,
        filteredRows,
        setAllFilters,
        'state': {pageIndex, pageSize},
      },
    },
    'data': {
      'dataTable': reportData,
      filteredRows,
      loading,
      isUserTde,
      dealerId,
    },
  };
};
